import { httpClient } from '../config';
import { appendIndustryIdToUrl } from '../utils/industryUtils';

// httpClient resolves with the error object on 4xx/5xx, so the response must be checked explicitly
export const fetchAdsIngestRunsSummary = async () => {
  const response = await httpClient(appendIndustryIdToUrl('/tables/ads_ingest_runs/summary'));
  if (!response || !response.json) {
    throw new Error((response && response.message) || 'Failed to load ingest runs summary');
  }
  return response.json;
};
